import React, { FC, useContext, useEffect } from 'react';
import styles from './ShowPartners.module.scss';
import { useStore } from '../../../../common';
import { AuthContext } from '../../../../logic';
import { Button } from 'esa-ui-library';

const ShowPartners: FC = (): JSX.Element => {
	const [state, dispatch] = useStore();
	const { selectedGame, gameData } = state;
	const { token } = useContext(AuthContext);

	const getGame = async () => {
		await dispatch('GAME_INIT', { token, id: selectedGame.internal_game_id });
	};

	useEffect(() => {
		if (selectedGame) {
			getGame();
		}
	}, [selectedGame]);

	const handleDelete = async (partnerId: number) => {
		if (!window.confirm('Are you sure you want to remove this partner?')) return;

		await dispatch('REMOVE_PARTNER', {
			token,
			gameId: selectedGame.internal_game_id,
			partnerId,
		});

		await getGame();
	};

	const assignedPartners = gameData?.assigned_partners || [];

	return (
		<section>
			<div className={styles.ShowProviders}>
				<h2>Assigned Partners</h2>
				<div className={styles.TableScroll}>
					<table>
						<thead>
							<tr>
								<th>Skin ID</th>
								<th>Name</th>
								{process.env.REACT_APP_SITE_TITLE?.includes('Italy') && <th>AAMS Game ID</th>}
								<th>Partner</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							{assignedPartners.map((assignedPartners: any) => (
								<tr key={assignedPartners.partner_id}>
									<td>{assignedPartners.partner_id}</td>
									<td>{assignedPartners.name}</td>
									{process.env.REACT_APP_SITE_TITLE?.includes('Italy') && <td>{assignedPartners.aams_game_id}</td>}
									<td>{assignedPartners.partner}</td>
									<td>
										<Button
											danger
											className={styles.DeleteButton}
											onClick={() => handleDelete(assignedPartners.partner_id)}
										>
											Delete
										</Button>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		</section>
	);
};

export { ShowPartners };
